import { Component } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-home-nav',
  templateUrl: './home-nav.component.html',
  styleUrls: ['./home-nav.component.scss'],
})
export class HomeNavComponent {
  screenType = ScreenType;
  isNavAtEnd: boolean = false;
  onNavScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    this.isNavAtEnd = atEnd;
  }
}
